const actions = {
};

export default actions;



// WEBPACK FOOTER //
// ./scripts/sky-lightbox/store/actions.js